<template>
  <div class="tabbar-page">
    <van-tabbar :value="active" @change="changeTabbar">
      <van-tabbar-item icon="home-o" @click="$router.push({ path: 'health-index' })">
        首页
      </van-tabbar-item>
      <van-tabbar-item icon="apps-o" @click="$router.push({ path: 'health-list' })">
        体检预约
      </van-tabbar-item>
      <van-tabbar-item icon="contact-o" @click="$router.push({ path: 'user-center-index' })" class="budo-10"> 我的
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: "tabbar-health",

  data() {
    return {
      // active: 0,
      moduleInfo: this.get_mall_module(),
    };
  },

  props: {
    active: { type: Number, default: 0 },
  },

  computed: {
    goodsCount: function () {
      const cart = this.$store.getters.cart;
      if (cart && Array.isArray(cart) && cart.length > 0) {
        return cart.length;
      }
      return 0;
    },
  },

  created() {
    budo_log.info("#41 moduleInfo", this.moduleInfo);
  },

  methods: {
    changeTabbar(index) { },
    toGoodList(path) {
      if (this.$route.name != path) {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
